import React, { useState } from 'react';
import './Login.css';

const Login = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    
    // Simple credential check
    if (formData.username === 'admin' && formData.password === 'admin123') {
      console.log('✅ Simple admin login successful!');
      
      // Store simple authentication state
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('adminToken', 'simple-admin-token'); // Added to match App.jsx check
      localStorage.setItem('authMethod', 'simple');
      localStorage.setItem('adminUsername', 'admin');
      
      alert('🎉 Login successful! Welcome to the admin panel.');
      onLogin();
    } else {
      alert('❌ Invalid credentials. Please use:\nUsername: admin\nPassword: admin123');
    }
    
    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1 className="login-title">🕉️ PoojaPath</h1>
          <h2 className="login-subtitle">Admin Portal</h2>
          <p className="login-description">
            ✨ Divine Access Gateway ✨
          </p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label className="form-label">👤 Username</label>
            <input
              type="text"
              value={formData.username}
              onChange={(e) => setFormData({...formData, username: e.target.value})}
              className="form-input"
              placeholder="Enter your username"
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">🔐 Password</label>
            <input
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({...formData, password: e.target.value})}
              className="form-input"
              placeholder="Enter your password"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`login-button ${loading ? 'loading' : ''}`}
          >
            {loading ? '⏳ Authenticating...' : '🚀 Login Now'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;